// @flow
import React, {PureComponent} from 'react';
import {Image, ScrollView, StyleSheet, View} from 'react-native';
import {BulletPoint, EmphasizedSubText, Text} from 'trpc-react-native-ui';
import {SafeAreaView} from 'react-native-safe-area-context';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import FullButton from '../../components/common/FullButtons/FullButton';
import * as Navigation from '../../lib/navigation.js';

export default class LostAndStolen extends PureComponent<Props> {
  styles = getStyles();

  suspensionConsequences = [
    I18n.t('Dashboard.LostAndStolen.consequence1'),
    I18n.t('Dashboard.LostAndStolen.consequence2'),
    I18n.t('Dashboard.LostAndStolen.consequence3'),
  ];

  goToPickLineToSuspend = () => Navigation.navigate('pickLineToSuspend');

  render() {
    const styles = this.styles;

    if (!this.props.hasActiveSubscriptions)
      return (
        <View style={styles.emptyContainer}>
          <Image source={theme.lostAndStolenImage} style={styles.image} />
          <Text style={styles.emptyText}>
            {I18n.t('Dashboard.LostAndStolen.noLineToSuspend')}
          </Text>
        </View>
      );

    return (
        <SafeAreaView style={styles.container} edges={['bottom', 'left', 'right']}>
          <ScrollView contentContainerStyle={styles.contentContainer}>
            <Image source={theme.lostAndStolenImage} style={styles.image} />
            <Text style={styles.conditionsText}>
              {I18n.t('Dashboard.LostAndStolen.conditions')}
            </Text>
            <EmphasizedSubText
              style={styles.adviseText}
              emphStyle={styles.adviseEmphasis}
              text={I18n.t('Dashboard.LostAndStolen.advise')}
            />
            <View style={styles.bulletPointsContainer}>
              {this.suspensionConsequences.map(
                (suspensionConsequenceText, index) => (
                  <BulletPoint
                    key={index}
                    text={suspensionConsequenceText}
                    containerStyle={styles.bulletPointContainerStyle}
                    bulletPointStyle={styles.bulletPointStyle}
                    textStyle={styles.bulletPointTextStyle}
                    emphStyle={styles.adviseEmphasis}
                  />
                ),
              )}
            </View>
          </ScrollView>
          <View style={styles.bottomPanel}>
            <FullButton
              onPress={this.goToPickLineToSuspend}
              text={I18n.t('Dashboard.LostAndStolen.pickALineButton')}
            />
          </View>
        </SafeAreaView>
    );
  }
}

type Props = StateProps;

export type StateProps = {
  hasActiveSubscriptions: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    safeareaview: {
      flex: 1,
      backgroundColor: 'transparent',
    },
    container: {
      flex: 1,
    },
    contentContainer: {
      alignItems: 'center',
      margin: 15,
    },
    bulletPointsContainer: {
      flex: 1,
      marginBottom: 15,
    },
    conditionsText: {
      fontSize: 22,
      textAlign: 'center',
    },
    adviseText: {
      fontSize: 18,
      marginTop: 14,
      marginBottom: 14,
    },
    adviseEmphasis: {
      fontWeight: 'bold',
    },
    bulletPointContainerStyle: {
      alignItems: 'flex-start',
      paddingRight: 20,
      paddingLeft: 21,
    },
    bulletPointStyle: {
      color: theme.defaultTextColor,
      marginTop: 5,
      fontSize: 12,
    },
    bulletPointTextStyle: {
      fontSize: 18,
    },
    emptyContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    emptyText: {
      textAlign: 'center',
      color: theme.emptyTextColor,
      fontSize: 16,
      marginBottom: 75,
    },
    image: {
      width: 100,
      height: 100,
      marginTop: 16,
      marginBottom: 29,
    },
    bottomPanel: {
      paddingVertical: 13,
      paddingHorizontal: 20,
      justifyContent: 'center',
      borderTopWidth: 1,
      borderTopColor: theme.bottomPanelBorderColor,
    },
  });
